import {UniversalDeviceDetectorService} from './core/services/universal-device-detector.service';
import {DeviceDetectorService} from 'ngx-device-detector';
import {CustomerFilterLanguage} from 'src/app/core/class/customer-filter-language';
import {RequestHandlerInterceptor} from './core/interceptors/request-handler.interceptor';
import {DashboardModule} from './modules/dashboard/dashboard.module';
import {DigitalModule} from './modules/digital/digital.module';
import {BrowserModule, HAMMER_GESTURE_CONFIG, HammerGestureConfig} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {NgxPaginationModule} from 'ngx-pagination';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from '@angular/common/http';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {BaseComponent} from 'src/app/shared/components/base/base.component';
import {DashboardComponent} from './modules/dashboard/dashboard.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AsyncPipe, DatePipe} from '@angular/common';
import {AuthenticationService} from './core/services/authentication.service';
import {JwtInterceptor} from './core/interceptors/jwt.interceptor';
import {BlockUIModule} from 'ng-block-ui';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {NotifierModule} from 'angular-notifier';
import {customNotifierOptions} from './core/models/notifier-option';
import {ForgotPasswordComponent} from './modules/forgot-password/forgot-password.component';
import {ToastrModule} from 'ngx-toastr';
import {Message} from './core/class/message';
import {SharedModule} from './shared/shared.module';
import {CommonCompModule} from './shared/components/common-comp/common-comp.module';
import {MaterialModule} from 'src/app/core/material';
import {RECAPTCHA_LANGUAGE, RecaptchaFormsModule, RecaptchaModule} from 'ng-recaptcha';
import {en_US, NgZorroAntdModule, NZ_I18N} from 'ng-zorro-antd';
import {environment} from '../environments/environment';
import {MockInterceptor} from './core/interceptors/mock.interceptor';
import {VerifyDocumentComponent} from 'src/app/modules/verify-document/verify-document.component';
import {PanelDocumentInfoComponent} from 'src/app/modules/verify-document/panel-document-info/panel-document-info.component';
import {DocumentModule} from './modules/dashboard/home/home-enterprise/document/document.module';
import {MAT_TOOLTIP_SCROLL_STRATEGY_FACTORY_PROVIDER} from '@angular/material/tooltip';
import {EnvServiceProvider} from 'src/app/core/services/env.service.provider';
import {AnonymousLoginComponent} from './modules/login/anonymous-login/anonymous-login.component';
import {AnonymousSignViewDetailComponent} from './modules/anonymous-view-detail/anonymous-sign-view-detail.component';
import {AnonymousSignFlowV2Component} from './modules/anonymous-view-detail/anonymous-sign-flow-v2/anonymous-sign-flow-v2.component';
import {AnonymousSignFlowComponent} from './modules/anonymous-view-detail/anonymous-sign-flow/anonymous-sign-flow.component';
// tslint:disable-next-line:max-line-length
import {AnonymousDeclineSignDocumentComponent} from './modules/anonymous-view-detail/anonymous-decline-sign-document/anonymous-decline-sign-document.component';
import {AnonymousDetailPanelComponent} from './modules/anonymous-view-detail/anonymous-detail-panel/anonymous-detail-panel.component';
// import { LandingPageModule } from './modules/landingpage/landingpage.module';
import {NgxExtendedPdfViewerModule} from "ngx-extended-pdf-viewer";
import {PageShortLinkComponent} from './modules/page-short-link/page-short-link.component';
import {BlankPageComponent} from './modules/blank-page/blank-page.component';
import {WebcamModule} from 'ngx-webcam';
import {SlickCarouselModule} from 'ngx-slick-carousel';
import {ContractLotModule} from './modules/dashboard/home/home-enterprise/contract-lot/contract-lot.module';
import { UserAddProcedureComponent } from './modules/dashboard/home/home-enterprise/user-config/user-procedure-management/user-add-procedure/user-add-procedure.component';
import { UserEditProcedureComponent } from './modules/dashboard/home/home-enterprise/user-config/user-procedure-management/user-edit-procedure/user-edit-procedure.component';
import { UserViewProcedureComponent } from './modules/dashboard/home/home-enterprise/user-config/user-procedure-management/user-view-procedure/user-view-procedure.component';
import {ProcedureComponent} from "./shared/components/procedure/procedure.component";
import { SigningDialogComponent } from 'src/app/modules/dashboard/home/home-enterprise/document/signing-dialog/signing-dialog.component';
import { ProcedureManagementModule } from './modules/dashboard/home/home-enterprise/procedure-management/procedure-management.module';
import {ViewProcedureComponent} from './modules/dashboard/home/home-enterprise/procedure-management/view-procedure/view-procedure.component';
import { EkycModule } from 'src/app/modules/dashboard/home/home-enterprise/document/ekyc/ekyc.module';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireMessagingModule } from '@angular/fire/messaging';
import { AngularFireModule } from '@angular/fire';
import { MessagingService } from './core/services/messaging-service';
import { SigningConfirmDialogComponent } from './modules/dashboard/home/home-enterprise/document/signing-confirm-dialog/signing-confirm-dialog.component';
import { AuthCallbackComponent } from './modules/auth-callback/auth-callback.component';
import * as firebase from 'firebase';
import {NotificationCmsComponent} from './shared/components/notification-cms/notification-cms.component';
import {VerifyEnterpriceDialogComponent} from "./shared/components/verify-enterprice-dialog/verify-enterprice-dialog.component";
import { ViewFilePdfComponent } from './shared/components/view-file-pdf/view-pdf.component';
import { DowloadAppComponent } from './modules/dowload-app/dowload-app.component';
import {
  AddCustomerApproveDialogComponent
} from "./shared/components/add-customer-approve-dialog/add-customer-approve-dialog.component";
import {MatRippleModule} from "@angular/material/core";

import { MatSelectModule } from '@angular/material/select';
import { PageErrorApiLimitComponent } from './modules/page-error-api-limit/page-error-api-limit.component';
import { ProcedureMohaComponent } from './shared/components/procedure-moha/procedure-moha.component';
import { ContractLotMohaModule } from './modules/dashboard/home/home-enterprise/contract-lot-moha/contract-lot-moha.module';
import { SigningDialogReportComponent } from './modules/dashboard/home/home-enterprise/document/sign-document-moha-report/signing-dialog-report/signing-dialog-report.component';
import { ContractLotStandardizedModule } from './modules/dashboard/home/home-enterprise/contract-lot-standardized/contract-lot-standardized.module';
firebase.initializeApp(environment.firebase);
import { ContractDigitalAddLotModule } from './modules/dashboard/home/home-enterprise/contract-digital-add-lot/contract-digital-add-lot.module';
// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

export const isMock = environment.mock;

@NgModule({
  declarations: [
    BaseComponent,
    AppComponent,
    DashboardComponent,
    // HomeComponent,
    ForgotPasswordComponent,
    VerifyDocumentComponent,
    PanelDocumentInfoComponent,
    AnonymousLoginComponent,
    AnonymousSignViewDetailComponent,
    AnonymousSignFlowV2Component,
    AnonymousSignFlowComponent,
    AnonymousDeclineSignDocumentComponent,
    AnonymousDetailPanelComponent,
    AnonymousDetailPanelComponent,
    PageShortLinkComponent,
    BlankPageComponent,
    ProcedureComponent,
    AddCustomerApproveDialogComponent,
    ViewFilePdfComponent,
    SigningDialogComponent,
    SigningDialogReportComponent,
    SigningConfirmDialogComponent,
    AuthCallbackComponent,
    DowloadAppComponent,
    PageErrorApiLimitComponent,
    ProcedureMohaComponent
  ],
  imports: [
    BrowserModule,
    MatSelectModule,
    AngularFireAuthModule,
    AngularFireMessagingModule,
    AngularFireModule.initializeApp(environment.firebase),
    AppRoutingModule,
    BrowserAnimationsModule,
    NgxPaginationModule,
    HttpClientModule,
    ReactiveFormsModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    FormsModule,
    SharedModule,
    DashboardModule,
    DigitalModule,
    ProcedureManagementModule,
    // LandingPageModule,
    MaterialModule,
    NotifierModule.withConfig(customNotifierOptions),
    BlockUIModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    ToastrModule.forRoot(), // ToastrModule added
    CommonCompModule,
    NgZorroAntdModule,
    DocumentModule,
    NgxExtendedPdfViewerModule,
    ContractLotModule,
    ContractLotMohaModule,
    ContractLotStandardizedModule,
    WebcamModule,
    SlickCarouselModule,
    EkycModule,
    MatRippleModule,
    ContractDigitalAddLotModule
    // EkycCameraModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: isMock ? MockInterceptor : RequestHandlerInterceptor,
      multi: true
    },
    { provide: NZ_I18N, useValue: en_US },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    {
      provide: RECAPTCHA_LANGUAGE,
      useValue: localStorage.getItem('__language') ? localStorage.getItem('__language') : 'vi'
    },
    // add module allow copy words on browser
    MAT_TOOLTIP_SCROLL_STRATEGY_FACTORY_PROVIDER,
    { provide: HAMMER_GESTURE_CONFIG, useClass: HammerGestureConfig },
    {
      provide: DeviceDetectorService,
      useClass: UniversalDeviceDetectorService
    },
    //
    DatePipe,
    AuthenticationService,
    Message,
    CustomerFilterLanguage,
    EnvServiceProvider,
    MessagingService,
    AsyncPipe,
  ],
  entryComponents: [
    AnonymousDeclineSignDocumentComponent,
    SigningDialogComponent,
    SigningDialogReportComponent,
    UserAddProcedureComponent,
    UserEditProcedureComponent,
    UserViewProcedureComponent,
    ProcedureComponent,
    AddCustomerApproveDialogComponent,
    SigningConfirmDialogComponent,
    NotificationCmsComponent,
    VerifyEnterpriceDialogComponent,
    ViewFilePdfComponent,
    ProcedureMohaComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

